import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { SortField } from '~/utils/types/common';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';
import { IFranchiseList, ISelectIFranchise } from '~/utils/interface/franchise';

export interface FranchiseState {
  selectFranchise: Array<ISelectIFranchise>;
  filter: IFranchiseFilter;
  currentPage: number;
  totalPages: number;
  needRefreshData: boolean;
  Franchises: Array<IFranchiseList>;
  selectedIds: Array<string>;
  FranchiseId: string;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
}

interface IFranchiseFilter {
  page?: number;
  limit?: number;
  search?: string;
  searchFields?: Array<string>;
  sort?: Array<SortField>;
}

const initialState: FranchiseState = {
  selectFranchise: [],
  currentPage: DEFAULT_PAGE,
  totalPages: 0,
  needRefreshData: false,
  filter: {
    page: 1,
    limit: ROWS_PER_PAGE,
    search: '',
    searchFields: [],
    sort: [],
  },
  selectedIds: [],
  Franchises: [],
  FranchiseId: '',
  openAlertDelete: false,
  menuSelectedId: undefined,
};

const FranchiseSlice = createSlice({
  name: 'franchise',
  initialState,
  reducers: {
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    setFilter(state, action: PayloadAction<IFranchiseFilter>) {
      state.filter = { ...state.filter, ...action.payload };
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
    changeFranchiseId(state, action: PayloadAction<string>) {
      state.FranchiseId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
  },
  extraReducers(builder) {},
});

export const franchiseActions = FranchiseSlice.actions;

const FranchiseReducer = FranchiseSlice.reducer;
export default FranchiseReducer;
